import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	recentSearchIconLabel: {
		id: 'dynamic-cards-search-page.dropdown_recent_icon_label',
		defaultMessage: 'Recent',
		description: 'Label text for recent icon',
	},
	removeRecentSearchIcon: {
		id: 'dynamic-cards-search-page.search-result.remove-recent-search',
		defaultMessage: 'Remove recent search icon',
		description: 'The icon that removes a recent search result',
	},
	removeRecentSearchSubheading: {
		id: 'dynamic-cards-search-page.search-result.remove-recent-search-result-subheading',
		defaultMessage: 'Recent search',
		description: 'Removes a recent search result',
	},
});
